import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import type { MonthlyByAgent } from '../services/leadStatsApi';

interface MonthComparisonCardProps {
  data: MonthlyByAgent[];
  selectedAgent: string | null;
}

export default function MonthComparisonCard({ data, selectedAgent }: MonthComparisonCardProps) {
  let currentMonth: number;
  let previousMonth: number;

  if (selectedAgent) {
    const agentData = data.find(d => d.agent_id === selectedAgent);
    currentMonth = agentData?.current_month || 0;
    previousMonth = agentData?.previous_month || 0;
  } else {
    currentMonth = data.reduce((sum, d) => sum + d.current_month, 0);
    previousMonth = data.reduce((sum, d) => sum + d.previous_month, 0);
  }

  const diff = previousMonth > 0
    ? Math.round(((currentMonth - previousMonth) / previousMonth) * 100)
    : currentMonth > 0 ? 100 : 0;

  const isUp = diff > 0;
  const isDown = diff < 0;

  const currentMonthName = new Date().toLocaleDateString('es-ES', { month: 'long' });
  const prevDate = new Date();
  prevDate.setMonth(prevDate.getMonth() - 1);
  const prevMonthName = prevDate.toLocaleDateString('es-ES', { month: 'long' });

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow h-full flex flex-col justify-between">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-900">Leads por mes</h3>
        <div className={`flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${
          isUp ? 'bg-emerald-50 text-emerald-600' :
          isDown ? 'bg-red-50 text-red-500' :
          'bg-gray-100 text-gray-500'
        }`}>
          {isUp ? <TrendingUp className="w-3.5 h-3.5" /> :
           isDown ? <TrendingDown className="w-3.5 h-3.5" /> :
           <Minus className="w-3.5 h-3.5" />}
          {isUp ? '+' : ''}{diff}%
        </div>
      </div>

      <div className="flex items-end gap-6">
        <div className="flex-1">
          <p className="text-[11px] text-gray-400 uppercase tracking-wider capitalize">{currentMonthName}</p>
          <p className="text-3xl font-bold text-gray-900 tabular-nums">{currentMonth.toLocaleString()}</p>
          <p className="text-[10px] text-gray-400 mt-0.5">Mes actual</p>
        </div>
        <div className="flex-1 text-right">
          <p className="text-[11px] text-gray-400 uppercase tracking-wider capitalize">{prevMonthName}</p>
          <p className="text-3xl font-bold text-gray-300 tabular-nums">{previousMonth.toLocaleString()}</p>
          <p className="text-[10px] text-gray-400 mt-0.5">Mes anterior</p>
        </div>
      </div>
    </div>
  );
}
